export default {
    cptDataForm: {
        dataText: '{"value":"1"}',
        dataSource: 1,
        pollTime: 0,
        apiUrl: '/text',
        sql: 'select id from test limit 1'
    },
    attribute:{
        cptTableData: [{ "name": "值", "value": "", "namekey": "value" }],
        label:'数字：',
        labelAlign:'right',
        labelWidth:100,
        placeholder:'请输入',
        min:0,
        max:1000,
        size:'medium',
        width:144,
        height:32,
        align:"center",
        isInput: true,
        indent:0,
        bgColor:'#00000000',
        theme:'row',
        textColor:'#ffffff',
        textPlaceholderColor: '#333',
        fontStyle:'normal',
        fontWeight:'normal',
        fontFamily:'微软雅黑',
        fontSize:12,
        borderSize:1,
        borderColor:'#333333',
        borderRadius:0,
        lineType:'solid',
        required:false,
        numbertype:"int",
        funText:'',
        panelBg:'#00000000',
        activeBgColor: '#2684ff',
        activeColor: '#2684ff',
        disableColor:'#ffffff',
        disableBg:'#00000000',
        bg:'#00000000',
        panelNum:'',
        activeNum: '',
        activeNum: '',
        disableBool:false,
        disableBool:false,
        bgBool:false,

        incNumberborderSize:1,
        decNumberborderSize:1,
        incNumberborderColor:'#333333',
        decNumberborderColor:'#333333',
        incNumberborderRadius:0,
        decNumberborderRadius:0,
        incNumberlineType:'solid',
        decNumberlineType:'solid',

        incNumberColor:'#fff',
        decNumberColor:'#fff',
        incNumberBg:'#00000000',
        decNumberBg:'#00000000',

        incNumberActiveborderSize:1,
        decNumberActiveborderSize:1,
        incNumberActivborderColor:'#2684ff',
        decNumberActivborderColor:'#2684ff',
        incNumberActivborderRadius:0,
        decNumberActivborderRadius:0,
        incNumberActivlineType:'solid',
        decNumberActivlineType:'solid',

        incNumberActivColor:'#fff',
        decNumberActivColor:'#fff',
        incNumberActivBg:'#2684ff',
        decNumberActivBg:'#2684ff',

        
    },
    interaction:{ intType: 'none'}
}